/**
 * @file: 通信模块
 * @author: xiaolong.huang@dmall.com
 */

import CEvent from '../utils/event';
import WhiteList from './whiteList';

const StageEvent = new CEvent();

 StageEvent.addFilter('on', function(eventName: string) {
     if (WhiteList.indexOf(eventName) < 0) {
         return false;
     }
 });

export {
    StageEvent
}
